import type { FC } from "react";

import { useCurrentStateAndParams } from "@uirouter/react";
import styled from "styled-components";

import { colorsPalettes, setFontVariant } from "@similarweb/styles";

import { KeywordsQueryBar } from "app/components/compare/KeywordsQueryBar/KeywordsQueryBar";
import type { IKeywordsQueryBarProps } from "app/components/compare/KeywordsQueryBar/KeywordsQueryBarTypes";
import { translate } from "app/filters/i18nFilter";
import { ActivationSetsQueryBarFilter } from "app/pages/activation/components/ActivationSetsQueryBarFilter/ActivationSetsQueryBarFilter";
import { FlexRowAlignCenter } from "app/pages/segments/geography/StyledComponents";

const MonitorKeywordsQueryBarContainer = styled(FlexRowAlignCenter)`
    justify-content: flex-start;
`;

const QueryBarContainer = styled.div`
    margin: 0 8px 0 16px;
`;

const SeperatorText = styled.span`
    ${setFontVariant("body1", colorsPalettes.carbon[300])}
    margin-right: 8px;
`;

const MONITOR_KEYWORDS_QUERY_BAR_DESCRIPTOR_TEXT = "keyword.analysis.monitor.keywords.query_bar.seperator.text";

interface IMonitorKeywordsQueryBar {
    queryBarProps: IKeywordsQueryBarProps;
}

export const MonitorKeywordsQueryBar: FC<IMonitorKeywordsQueryBar> = ({ queryBarProps }) => {
    const { activationSetId } = useCurrentStateAndParams().params;
    return (
        <MonitorKeywordsQueryBarContainer>
            <QueryBarContainer>
                <KeywordsQueryBar {...queryBarProps} />
            </QueryBarContainer>
            {activationSetId ? (
                <SeperatorText>{translate(MONITOR_KEYWORDS_QUERY_BAR_DESCRIPTOR_TEXT)}</SeperatorText>
            ) : null}
            <ActivationSetsQueryBarFilter />
        </MonitorKeywordsQueryBarContainer>
    );
};
